export default {
      id: "icon--datepicker-arrow-grey-usage",
      viewBox: "0 0 21 21",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--datepicker-arrow-grey-usage",
      toString: function () {
        return this.url;
      }
    }